import parseColor from "color";
function swatchToColorString(swatch, alpha, defaultValue) {
  if (swatch == null) {
    return defaultValue === void 0 ? void 0 : safeParseColor(defaultValue).rgb().string();
  }
  return parseColor({
    h: swatch.hue,
    s: swatch.saturation,
    l: swatch.lightness
  }).alpha(alpha).rgb().string();
}
function safeParseColor(value) {
  try {
    return parseColor(value);
  } catch {
    return parseColor();
  }
}
export {
  swatchToColorString
};
//# sourceMappingURL=conversion.js.map